import DocumentsContainer from "./Documents.container";

export default DocumentsContainer;
